import React from 'react';
import T from 'prop-types';
// components
import MovingBlobs from './MovingBlobs';
// utils
import color from 'color';
// styles
import classnames from 'classnames/bind';
import styles from './Background.mod.css';

let cx = classnames.bind(styles);

const Background = ({ children, type, blobs, userColor }) => {
  const waveStyle =
    type === 'profile'
      ? {
          backgroundColor: color(userColor).fade(0.4)
        }
      : {};

  return (
    <div className={cx('app-background', type)}>
      <div className={cx('bg-underlayer')}>
        <div className={cx('bg-figure-1')} style={waveStyle} />
        <div className={cx('bg-figure-2')} />
        <div className={cx('bg-figure-3')} />
        <div className={cx('bg-congrats')} />
      </div>
      <MovingBlobs blobs={blobs} />
      {children}
    </div>
  );
};

Background.propTypes = {
  type: T.string,
  children: T.oneOfType([T.node, T.element]).isRequired,
  blobs: T.bool.isRequired,
  userColor: T.string
};

export default Background;



// WEBPACK FOOTER //
// ./src/components/Background/Background.js